import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireinkashtishrigonda() {



const cardData =
  {
    keyword: 'Bus Hire in Kashti Shrigonda',
    heading: 'Sanavi Travels: Bus Hire in Kashti Shrigonda',
    headingDescription: 'Sanavi Travels offers dependable and professional Bus Hire in Kashti Shrigonda, providing safe, spacious, and comfortable transportation solutions for families, local residents, corporate groups, schools, wedding parties, picnic tours, and outstation travelers. Kashti, located in Shrigonda taluka of Ahmednagar district, is an important local hub surrounded by agricultural villages, small industries, and social centers, creating frequent demand for organized group transportation. To meet these needs, we provide a diverse fleet of AC buses, Non-AC buses, mini buses, luxury coaches, and higher seating-capacity buses suitable for both short-distance and long-distance travel. Each bus is well-maintained and designed with comfortable seating, proper ventilation, smooth suspension, and adequate luggage space to ensure passengers enjoy a relaxed and safe journey. With experienced drivers who are familiar with Kashti, Shrigonda, and nearby routes, flexible rental options including one-way, round-trip, and multi-day packages, transparent pricing without hidden charges, and 24/7 customer support, bus hire in Kashti Shrigonda becomes simple and stress-free. Choose Sanavi Travels for trusted bus hire services in Kashti Shrigonda, ensuring punctuality, safety, comfort, and smooth group travel for every occasion.',

    top: 'Top Places to Visit Near Kashti Shrigonda with Sanavi Travels',


"topPlaces": [
  {
    "title": "Kashti Town",
    "description": "Kashti is a prominent town in Shrigonda taluka, known for its agricultural activity, weekly markets, educational institutions, and close-knit community life. The town serves as a central meeting point for nearby villages, making it a frequent location for weddings, social gatherings, and local events. Group travel by bus is commonly preferred here to manage large crowds efficiently, ensure timely arrivals, and provide comfortable transportation for families and guests. Kashti’s road connectivity with Shrigonda and surrounding areas makes bus hire a practical and economical choice for both local and regional travel."
  },
  {
    "title": "Shrigonda Town",
    "description": "Shrigonda is the taluka headquarters and a major commercial and administrative center near Kashti. It features government offices, markets, hospitals, and educational institutions that attract daily visitors from Kashti and surrounding villages. Bus travel between Kashti and Shrigonda is commonly used for official work, shopping trips, school excursions, and social visits. Hiring a bus ensures organized travel for groups, saving time and providing convenience, especially during peak days and festival seasons."
  },
  {
    "title": "Agricultural Villages Around Kashti",
    "description": "The region surrounding Kashti consists of fertile agricultural villages known for sugarcane, grains, and seasonal crops. These villages are often visited for family functions, rural exposure programs, school tours, and community events. Bus rentals are ideal for navigating rural roads safely and transporting groups together, ensuring comfort for passengers of all age groups while supporting local travel needs."
  },
  {
    "title": "Local Temples and Spiritual Sites",
    "description": "Kashti and nearby areas are home to several village temples and spiritual centers that attract devotees throughout the year, especially during festivals and religious occasions. Group travel by bus makes pilgrimages easier, more organized, and safer, allowing families and devotees to travel together without the stress of multiple vehicles."
  },
  {
    "title": "Weekly Markets and Mandis",
    "description": "Weekly markets in and around Kashti draw traders, farmers, and visitors from nearby villages. These markets are vibrant centers of commerce and social interaction. Bus hire services are often used for group visits, trader associations, and community travel, offering an economical and convenient way to reach market areas."
  },
  {
    "title": "Wedding Lawns and Event Venues",
    "description": "Several wedding halls, banquet lawns, and event venues around Kashti depend on bus rentals for guest transportation. Buses help manage large gatherings efficiently by ensuring guests arrive on time, reducing parking issues, and maintaining smooth event coordination."
  },
  {
    "title": "Picnic and Leisure Spots",
    "description": "Open spaces, small water bodies, and leisure areas near Kashti are popular for family outings, school picnics, and social group trips. Hiring a bus allows groups to travel together safely, making the journey enjoyable and well-coordinated."
  },
  {
    "title": "Educational Institutions",
    "description": "Schools and colleges in and around Kashti frequently organize educational tours, sports events, and cultural programs. Bus hire provides safe and reliable transportation for students and staff, ensuring discipline, supervision, and punctuality during trips."
  },
  {
    "title": "Nearby Industrial and Commercial Areas",
    "description": "Small industrial units and commercial zones near Kashti generate regular movement of employees and visitors. Bus services are often hired for corporate travel, staff transport, and organized group movement."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Kashti is well connected to outstation destinations such as Ahmednagar, Pune, Solapur, Shirdi, and other nearby towns. Bus rentals are ideal for long-distance group travel, offering comfort, safety, and cost-effective transportation."
  }
]
,



"services": [
{
"name": "Bus Hire in Kashti Shrigonda",
"description": "Bus Hire in Kashti Shrigonda provides reliable and comfortable buses for families, social groups, schools, corporate clients, and tourists. This service is ideal for weddings, picnics, school trips, religious journeys, and outstation travel. Our buses are spacious, clean, and well-maintained, featuring comfortable seating, proper ventilation, smooth suspension, and adequate luggage space. Professional drivers ensure disciplined driving, punctual pickups, and safe journeys, making group travel smooth and stress-free."
},
{
"name": "Bus on Rent Kashti Shrigonda",
"description": "Bus on Rent Kashti Shrigonda offers flexible rental solutions for short-term and long-term travel needs. Whether for a local function, social gathering, or extended tour, this service ensures organized transportation with reliable scheduling and suitable bus options."
},
{
"name": "AC Bus Hire Kashti",
"description": "AC Bus Hire Kashti is suitable for travelers seeking enhanced comfort during travel, especially in hot weather and on longer routes. Fully air-conditioned interiors, cushioned seating, and smooth ride quality make AC buses ideal for weddings, corporate travel, and outstation trips."
},
{
"name": "Non AC Bus Rental Kashti",
"description": "Non AC Bus Rental Kashti provides budget-friendly transportation for short-distance travel, rural routes, school trips, and local group journeys. These buses are reliable, spacious, and economical, making them suitable for cost-conscious travel."
},
{
"name": "Luxury Bus Hire Kashti Shrigonda",
"description": "Luxury Bus Hire Kashti Shrigonda delivers premium travel experiences with modern interiors, elegant seating arrangements, and enhanced comfort features. Ideal for weddings, VIP travel, and special occasions, these buses ensure a refined journey."
},
{
"name": "Mini Bus Hire Kashti",
"description": "Mini Bus Hire Kashti is perfect for small to medium-sized groups such as family outings, office teams, and local events. Mini buses offer easy maneuverability, comfort, and economical pricing while maintaining safety standards."
},
{
"name": "32 Seater Bus Hire Kashti",
"description": "32 Seater Bus Hire Kashti is suitable for medium-sized groups including school excursions, office outings, and community events. These buses balance seating capacity and comfort for smooth group travel."
},
{
"name": "35 Seater Bus Rental Kashti",
"description": "35 Seater Bus Rental Kashti supports larger group travel needs such as weddings, religious tours, and long-distance journeys. Spacious seating and professional drivers ensure organized transportation."
},
{
"name": "Bus Hire Kashti for Wedding",
"description": "Bus Hire Kashti for Wedding ensures timely and coordinated transportation for wedding guests, family members, and relatives, reducing travel stress and improving event management."
},
{
"name": "Bus Hire Kashti for Corporate Travel",
"description": "Bus Hire Kashti for Corporate Travel supports employee transport, meetings, conferences, and corporate outings with a focus on punctuality and professionalism."
},
{
"name": "Bus Hire Kashti for Picnic",
"description": "Bus Hire Kashti for Picnic offers safe and comfortable transportation for school picnics, family outings, and leisure trips, ensuring group coordination and safety."
},
{
"name": "Bus Rental Kashti for Outstation",
"description": "Bus Rental Kashti for Outstation provides dependable long-distance transportation to nearby cities and pilgrimage destinations with passenger comfort as a priority."
},
{
"name": "Bus Hire Kashti with Driver",
"description": "Bus Hire Kashti with Driver offers chauffeur-driven buses where experienced drivers manage routes, traffic, and safety, allowing passengers to relax."
},
{
"name": "Cheap Bus Hire Kashti Shrigonda",
"description": "Cheap Bus Hire Kashti Shrigonda provides economical bus rental options for groups seeking affordable transportation without compromising safety or reliability."
},
{
"name": "Best Bus Service Kashti",
"description": "Best Bus Service Kashti is known for clean buses, disciplined drivers, transparent pricing, and customer-focused service, making Sanavi Travels a preferred choice."
}
],
"tableData": [
["Bus Hire in Kashti Shrigonda", "Bus on Rent Kashti Shrigonda"],
["AC Bus Hire Kashti", "Non AC Bus Rental Kashti"],
["Luxury Bus Hire Kashti Shrigonda", "Mini Bus Hire Kashti"],
["32 Seater Bus Hire Kashti", "35 Seater Bus Rental Kashti"],
["Wedding Bus Kashti", "Corporate Bus Kashti"],
["Picnic Bus Kashti", "Outstation Bus Kashti"],
["Bus Hire Kashti with Driver", "Cheap Bus Hire Kashti Shrigonda"],
["Best Bus Service Kashti", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus Hire in Kashti Shrigonda with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels is a trusted provider of bus hire services in Kashti Shrigonda, offering reliable transportation for families, schools, corporate groups, and social events."
  },
  {
    "WhyChooseheading": "Well-Maintained and Comfortable Buses",
    "WhyChoosedescription": "Our buses are regularly serviced, clean, and designed to provide a smooth and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Experienced and Local Drivers",
    "WhyChoosedescription": "Our drivers are familiar with Kashti, Shrigonda, and nearby routes, ensuring safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing Policy",
    "WhyChoosedescription": "We offer clear and honest pricing with no hidden charges, ensuring complete transparency."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and journey coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "We provide hourly, full-day, multi-day, and customized bus hire plans to suit different travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure passenger safety."
  },
  {
    "WhyChooseheading": "Reliable and Punctual Service",
    "WhyChoosedescription": "We ensure on-time pickups and disciplined operations, making Sanavi Travels a dependable choice in Kashti."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus hire services in Kashti Shrigonda?',
    answer: 'Yes, Sanavi Travels offers reliable bus hire services in Kashti Shrigonda for all types of group travel.'
  },
  {
    question: 'How can I book a bus in Kashti?',
    answer: 'You can book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available in Kashti?',
    answer: 'We offer AC buses, Non-AC buses, mini buses, luxury buses, 32-seater and 35-seater buses.'
  },
  {
    question: 'Is bus hire available for weddings and corporate travel?',
    answer: 'Yes, we provide dedicated bus services for weddings, corporate travel, and social events.'
  },
  {
    question: 'Are buses sanitized before every trip?',
    answer: 'Yes, all buses are cleaned and sanitized before each journey.'
  },
  {
    question: 'Is bus service available for outstation travel?',
    answer: 'Yes, we offer bus rentals from Kashti to various outstation destinations.'
  },
  {
    question: 'What payment options are accepted?',
    answer: 'We accept UPI, debit cards, credit cards, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our customer support team remains available throughout the journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ashok Shinde',
    feedback: 'We hired a bus from Kashti for a wedding in Shrigonda. The service was punctual and very comfortable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Rutuja Pawar',
    feedback: 'Sanavi Travels arranged a bus for our picnic from Kashti. Smooth journey and excellent coordination.',
    rating: 5
  }
];













  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire in Kashti Shrigonda - Sanavi Travels",
  "description": "Sanavi Travels provides bus hire in Kashti Shrigonda for weddings, corporate travel, picnics, and outstation trips. We offer AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with experienced drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "190"
  }
};



  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus Hire in Kashti Shrigonda | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus hire in Kashti Shrigonda with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/217.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireinkashtishrigonda;